var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C9.87979 6.00086 9.76072 6.02339 9.6485 6.0665L8.4495 5.085C8.479 4.978 8.5 4.867 8.5 4.75C8.5 4.057 7.943 3.5 7.25 3.5C6.557 3.5 6 4.057 6 4.75C6 4.948 6.05 5.1325 6.131 5.2985L4.6765 7.0175C4.6183 7.00645 4.55924 7.00059 4.5 7C4.4105 7 4.326 7.015 4.244 7.037L2.9625 5.7555C2.985 5.674 3 5.5895 3 5.5C3 4.946 2.554 4.5 2 4.5C1.446 4.5 1 4.946 1 5.5C1 6.054 1.446 6.5 2 6.5C2.0895 6.5 2.174 6.485 2.256 6.463L3.5375 7.7445C3.51401 7.82769 3.5014 7.91357 3.5 8C3.5 8.554 3.946 9 4.5 9C5.054 9 5.5 8.554 5.5 8C5.5 7.8815 5.476 7.77 5.4385 7.6645L6.895 5.9435C7.0085 5.9765 7.126 6 7.25 6C7.44727 5.99853 7.6414 5.95038 7.8165 5.8595L9.016 6.841C9.00643 6.89349 9.00108 6.94666 9 7C9 7.554 9.446 8 10 8C10.554 8 11 7.554 11 7C11 6.446 10.554 6 10 6Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/Stats.2b02254edc12878d4d92f2450e6b117c.svg";
export { ForwardRef as ReactComponent };